import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  SetProfile,
  UserDetail,
  getProduct,
  SetAddres,
  UserAddress,
  BasketHistory,
} from "../axios";
import { toast } from "react-toastify";
// import moment from "moment-jalaali";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/configureStore";
import {
  fetchLibraryAdapterAsync,
  librarySelectors,
} from "./myLibrary/MyLibrarySlice";
import { LibraryItems } from "../models/library";
import { BasketContext } from "../context/BasketProvider";
import moment from "moment-jalaali";
import OrderModal from "../components/OrderModal";

export const StateList = [
  { name: "آذربایجان شرقی" },
  { name: "آذربایجان غربی" },
  { name: "اصفحان" },
  { name: "اردبیل" },
  { name: "ایلام" },
  { name: "البرز" },
  { name: "تهران" },
  { name: "بوشهر" },
  { name: "خراسان جنوبی" },
  { name: "چهارمحال و بختیاری" },
  { name: "خراسان شمالی" },
  { name: "خراسان رضوی" },
  { name: "زنجان" },
  { name: "خوزستان" },
  { name: "سیستان و بلوچستان" },
  { name: "سمنان" },
  { name: "قزوین" },
  { name: "فارس" },
  { name: "کردستان" },
  { name: "قم" },
  { name: "کرمانشاه" },
  { name: "کرمان" },
  { name: "گلستان" },
  { name: "کهگیلویه و بویراحمد" },
  { name: "گیلان" },
  { name: "لرستان" },
  { name: "مرکزی" },
  { name: "مازندران" },
  { name: "همدان" },
  { name: "هرمزگان" },
  { name: "یزد" },
];

const MyAccount = () => {
  const { getBasketHistory, orders, basketHistoryStatus } =
    useContext<any>(BasketContext);

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    getBasketHistory();
  }, []);

  const [step, setStep] = useState(1);
  const [stepHistory, setStepHistory] = useState(1);
  const [firstName, setFirstName] = useState("");
  const [sureName, setSureName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [showOrdersModal, setShowOrdersModal] = useState<number | null>(null);

  const [titleAddres, settitleAddres] = useState("");
  const [wholeAddres, setwholeAddres] = useState("");
  const [basketHistoryItems, setBasketHistoryItems] = useState<LibraryItems[]>(
    []
  );
  const [postalcode, setpostalcode] = useState("");

  const [loading, setloading] = useState(true);


  const navigate = useNavigate();
  let phoneNumberLS = localStorage.getItem("phonenumber");
  // console.log("phoneNumberLS=> ", phoneNumberLS);
  useEffect(() => {
    const fecthBasketHistoryItems = async () => {
      const basketHistoryItems = await BasketHistory(phoneNumberLS);
      setBasketHistoryItems(
        basketHistoryItems.data.filter(
          (item: LibraryItems) => item.description !== ""
        )
      );
    };
    fecthBasketHistoryItems();
    phoneNumberLS && setPhoneNumber(phoneNumberLS);

    UserDetail(phoneNumberLS).then(({ data }) => {
      setFirstName(data[0]?.name);
      setSureName(data[0]?.family);
      setEmail(data[0]?.email);
    });
    callAdress();
  }, []);

  // console.log("baskethisitems" , basketHistoryItems);
  

  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.account);

  var arrayClone: any[] = Object.assign([], orders);

  const newValues: LibraryItems[] = arrayClone.filter(
    (item) => item.userAddressID > 0
  );

  // console.log("newvalues" , newValues);
  
  const getExtension = (id: number, filename: string) => {
    if (typeof filename === "string") {
      let arr = filename.split(".");
      let extension = arr.pop();
      if (extension === "pdf") {
        navigate(`/pdf-view/${id}`);
      } else {
        navigate(`/video-view/${id}`);
      }
    } else {
      console.log("file name is not a string type");
    }
  };

  const callAdress = () => {
    UserAddress(localStorage.getItem("phonenumber")).then(({ data }) => {
      data[data.length - 1]?.title &&
        settitleAddres(data[data.length - 1].title);
      data[data.length - 1]?.address1 &&
        setwholeAddres(data[data.length - 1].address1);
      data[data.length - 1]?.codePosti &&
        setpostalcode(data[data.length - 1].codePosti);
    });
  };

  const submitDetailes = (e: any) => {
    e.preventDefault();
    SetProfile(phoneNumber, firstName, sureName, email).then(({ data }) => {
      toast.success("اطلاعات حساب به روزرسانی شد");
    });
  };

  const submitAddres = (e: any) => {
    e.preventDefault();
    SetAddres(phoneNumber, titleAddres, wholeAddres, 0, 0, postalcode , "", "").then(
      ({ data }) => {
        toast.success("اطلاعات آدرس به روزرسانی شد");
      }
    );
    callAdress();
  };

  const showDownload = (e: any, index: number) => {
    e.preventDefault();
    setStepHistory(2);
    // setFavorites([]);
    // @ts-ignore
    getProduct(arrayClone[index].productID).then(({ data }) => {
      // @ts-ignore
      setFavorites((favorites) => [...favorites, data[0]]);
      setloading(false);
    });

    // BasketHistoryDeatils(item.id).then(({ data }) => {
    //   data.map((item) => {
    //     console.log("item in basket history detail", item);
    //     getProduct(item.productID).then(({ data }) => {
    //       console.log("item get product", data);
    //       setFavorites((favorites) => [...favorites, data[0]]);
    //       // setFavorites([...favorites, data[0]]);
    //     });
    //   });
    // });
  };

  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  //handling open and closing order modals
  const handleOpenModal = (id: number) => {
    if (showOrdersModal === id) {
      setShowOrdersModal(null);
    } else {
      setShowOrdersModal(id);
    }
  };

  // console.log("new values" , newValues);
  

  return (
    <React.Fragment>
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <Link to="/">خانه</Link>
                  </li>
                  <li>حساب کاربری</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="main_content_area">
        <div className="container">
          <div className="account_dashboard">
            <div className="row">
              <div className="col-sm-12 col-md-3 col-lg-3">
                <div className="dashboard_tab_button">
                  <ul role="tablist" className="nav flex-column dashboard-list">
                    <li>
                      <a
                        onClick={() => setStep(1)}
                        style={{ color: "white" }}
                        className="nav-link active"
                      >
                        داشبورد
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setStep(2)}
                        style={{ color: "white" }}
                        className="nav-link"
                      >
                        سفارشات
                      </a>
                    </li>
                    <li>
                      <a
                        href="/myLibrary"
                        style={{ color: "white" }}
                        className="nav-link"
                      >
                      کتابخانه من
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setStep(3)}
                        style={{ color: "white" }}
                        className="nav-link"
                      >
                        آدرس ها
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={() => setStep(4)}
                        style={{ color: "white" }}
                        className="nav-link"
                      >
                        جزئیات حساب
                      </a>
                    </li>
                    <li>
                      <a
                        style={{ color: "white" }}
                        onClick={() => {
                          const keepPrefix = "pdf_highlights_";
                          const keptEntries: Record<string, string> = {};
                      
                          // Step 1: Collect all highlight keys and values
                          for (let i = 0; i < localStorage.length; i++) {
                            const key = localStorage.key(i);
                            if (key && key.startsWith(keepPrefix)) {
                              const value = localStorage.getItem(key);
                              if (value !== null) {
                                keptEntries[key] = value;
                              }
                            }
                          }
                      
                          // Step 2: Clear everything
                          localStorage.clear();
                      
                          // Step 3: Restore the highlights
                          Object.entries(keptEntries).forEach(([key, value]) => {
                            localStorage.setItem(key, value);
                          });
                      
                          // Step 4: Navigate and reload
                          navigate("/");
                          window.location.reload();
                        }}
                        className="nav-link"
                      >
                        خروج
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-12 col-md-9 col-lg-9">
                <div className="tab-content dashboard_content">
                  {step === 1 ? (
                    <div className="tab-pane fade show active" id="dashboard">
                      <h3>داشبورد </h3>
                      <p>
                        در این بخش می توانید اطلاعات حساب خود را مدیریت کنید
                      </p>
                    </div>
                  ) : step === 2 ? (
                    <div className="tab-pane fade show active" id="orders">
                      <h3>سفارشات</h3>
                      <div className="d-flex mb-4">
                        <span className="text-red">*</span>
                        <p>
                          در صورت سفارش نسخه چاپی کتابها، بعد از تحویل به اداره
                          پست، کد پیگیری در این بخش نمایش داده میشود و در صورت
                          تهیه محصولات دیجیتال، آنها را از قسمت کتابخانه من،
                          مشاهده بفرمایید.

                          
                        
                      <Link target="_blank" to={"https://t.me/atropine_admin"}>{"(اگر کد رهگیری را مشاهده نمیکنید, روز بعد از سفارش تلگرام پیام دهید)"}</Link>
                        </p>
                      </div>
                      <div className="table-responsive">
                        {user && basketHistoryStatus.includes("pending") ? (
                          <div className="loader-6 centerLoader">
                            <span></span>
                          </div>
                        ) : (
                          <table className="table border">
                            <thead>
                              <tr>
                                <th>ردیف</th>
                                <th>شناسه</th>
                                <th>تاریخ</th>
                                <th>کد پیگیری</th>
                                <th>جزئیات</th>
                              </tr>
                            </thead>
                            <tbody>
                              {newValues?.reverse()?.map((item, index) => (
                                <React.Fragment key={index}>
                                  <tr key={index}>
                                    <td className="border-right">{index}</td>
                                    <td className="border-right">{item.id}</td>
                                    <td>
                                      {moment(item.date).format("jYYYY/jM/jD")}{" "}
                                    </td>
                                    <td>
                                      {basketHistoryItems[index] &&
                                      basketHistoryItems[index].transactionID
                                        ? basketHistoryItems[index]
                                            .transactionID
                                        : "-"}
                                    </td>
                                    <td className="p-3">
                                      <button
                                        onClick={() => handleOpenModal(item.id)}
                                        className="showOrders-btn"
                                      >
                                        مشاهده جزئیات
                                      </button>
                                    </td>
                                  </tr>

                                  {item.id === showOrdersModal ? (
                                    <OrderModal basketId={item.id} />
                                  ) : null}
                                </React.Fragment>
                              ))}
                            </tbody>
                          </table>
                        )}
                        {basketHistoryStatus === "idle" && newValues.length === 0 ? (
                          <span>
                            موردی برای نمایش وجود ندارد 
                          </span>
                        ) : basketHistoryStatus === "error" ? (
                          <span>
                            در نمایش دیتا مشکل پیش آمده مجدد تلاش کنید
                          </span>
                        ) : null}
                      </div>
                    </div>
                  ) : step === 3 ? (
                    <div
                      className="tab-pane fade show active"
                      id="account-details"
                    >
                      <h3>آدرس</h3>
                      <div className="login">
                        <div className="login_form_container">
                          <div className="account_login_form">
                            <form action="#">
                              {/* --------------- چون فیلدی نداره فقط برای حالت نمایشی ازش استفاده شده فعلا کامنت شد تا ای پی آی زده شه */}
                              {/* <label>شهر</label>
                              <select
                                onChange={(e) => {
                                  settitleAddres(e.target.value);
                                  // setwholeAddres(listOfAddress[e.target.value].address1);
                                  // setpostalcode(listOfAddress[e.target.value].codePosti);
                                }}
                              >
                                {StateList.map((item, index) => (
                                  <option value={index}>{item.name === titleAddres ? titleAddres : item.name}</option>
                                ))}
                              </select> */}

                              <br />
                              <label>نام</label>
                              <input
                                value={titleAddres}
                                onChange={(e) => settitleAddres(e.target.value)}
                                type="text"
                                placeholder="برای مثال: خانه"
                              ></input>
                              <label>آدرس کامل</label>
                              <textarea
                                value={wholeAddres}
                                onChange={(e) => setwholeAddres(e.target.value)}
                              ></textarea>
                              <label>کد پستی</label>
                              <input
                                type="text"
                                value={postalcode}
                                onChange={(e) => setpostalcode(e.target.value)}
                              ></input>

                              <div className="save_button primary_btn default_button">
                                <button
                                  onClick={(e) => submitAddres(e)}
                                  type="submit"
                                >
                                  ذخیره
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : step === 4 ? (
                    <div
                      className="tab-pane fade show active"
                      id="account-details"
                    >
                      <h3>جزئیات حساب </h3>
                      <div className="login">
                        <div className="login_form_container">
                          <div className="account_login_form">
                            <form action="#">
                              {/* <p>
                                حساب کاربری دارید؟ <astyle={{color:"white"}} >وارد شوید!</astyle=>
                              </p> */}
                              {/* <div className="input-radio">
                                <span className="custom-radio">
                                  <label>
                                    <input
                                      type="radio"
                                      value="1"
                                      name="id_gender"
                                    ></input>{" "}
                                    آقا
                                  </label>
                                </span>
                                <span className="custom-radio">
                                  <label>
                                    <input
                                      type="radio"
                                      value="1"
                                      name="id_gender"
                                    ></input>{" "}
                                    خانم
                                  </label>
                                </span>
                              </div> */}
                              <br />
                              <label>نام</label>
                              <input
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                type="text"
                                name="first-name"
                              ></input>
                              <label>نام خانوادگی</label>
                              <input
                                value={sureName}
                                onChange={(e) => setSureName(e.target.value)}
                                type="text"
                                name="last-name"
                              ></input>
                              <label>ایمیل</label>
                              <input
                                type="email"
                                name="email-name"
                                dir="ltr"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                              ></input>
                              <label>شماره تماس</label>
                              <input
                                type="text"
                                name="phonenumber-name"
                                disabled={true}
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                              ></input>
                              {/* <label>تاریخ تولد</label>
                              <input
                                type="text"
                                placeholder="YYYY/MM/DD"
                                value=""
                                name="birthday"
                              ></input>
                              <span className="example">(مثال: 1397/05/26)</span> */}
                              {/* <br />
                              <span className="custom_checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    value="1"
                                    name="optin"
                                  ></input>{" "}
                                  دریافت پیشنهادات ویژه
                                </label>
                              </span>
                              <br /> */}
                              {/* <span className="custom_checkbox">
                                <label>
                                  <input
                                    type="checkbox"
                                    value="1"
                                    name="newsletter"
                                  ></input>{" "}
                                  عضویت در خبرنامه ما
                                  <br />
                                  <em>
                                    لورم ایپسوم متن ساختگی با تولید سادگی
                                    نامفهوم از صنعت چاپ و با استفاده از طراحان
                                    گرافیک است. چاپگرها و
                                  </em>
                                </label>
                              </span> */}
                              <div className="save_button primary_btn default_button">
                                <button
                                  onClick={(e) => submitDetailes(e)}
                                  type="submit"
                                >
                                  ذخیره
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default MyAccount;
